import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { ModalVariadoComponent } from 'src/app/shared/modal-variado/modal-variado.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class ModalVariadoService {
  public icono: string;
  public titulo: string;
  public textoDescriptivo: string;
  public esModalProceso: boolean;

  constructor(public dialog: MatDialog) { }

  modalConfirmacion(textoDescriptivo){
    this.icono = './assets/icons/icon-exitosa.svg';
    this.titulo = '¡Consulta exitosa!';
    textoDescriptivo = textoDescriptivo;
    this.esModalProceso = false;
    let config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo : this.titulo,
      textoDescriptivo: textoDescriptivo,
      esModalProceso : this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: 'alertdialog'
    };
    this.dialog
    .open(ModalVariadoComponent, config)
    .afterClosed()
  }

  modalAlerta(textoDescriptivo) {
    this.icono = "./assets/icons/warning-yellow.svg";
    this.titulo = "Importante";
    textoDescriptivo = textoDescriptivo;
    this.esModalProceso = false;
    let config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo: this.titulo,
      textoDescriptivo: textoDescriptivo,
      esModalProceso: this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: "alertdialog",
    };
    this.dialog.open(ModalVariadoComponent, config).afterClosed();
  }

  modalError(textoDescriptivo){
    this.icono = './assets/icons/icon-no-exitosa.svg';
    this.titulo = 'Consulta sin éxito';
    textoDescriptivo = textoDescriptivo;
    this.esModalProceso = false;
    let config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo : this.titulo,
      textoDescriptivo: textoDescriptivo,
      esModalProceso : this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: 'alertdialog'
    };
    this.dialog
    .open(ModalVariadoComponent, config)
    .afterClosed()
  }

  ModalProceso(textoDescriptivo){
    this.icono = '';
    this.titulo = 'Un momento por favor';
    textoDescriptivo = textoDescriptivo;
    this.esModalProceso = true;
    let config = new MatDialogConfig();
    config.data = {
      icono: this.icono,
      titulo : this.titulo,
      textoDescriptivo: textoDescriptivo,
      esModalProceso : this.esModalProceso,
      botones: { enviar: "Aceptar" },
      role: 'alertdialog'
    };
    this.dialog
    .open(ModalVariadoComponent, config)
    .afterClosed()
  }
}
